// customFieldsSlice.ts
import { StateCreator } from "zustand";
import { CustomField, CustomFieldsStore } from "./types";

export const createCustomFieldsSlice: StateCreator<
  { customFields: CustomFieldsStore },
  [],
  [["zustand/immer", never]],
  CustomFieldsStore
> = (set) => ({
  fields: [],
  setFields: (fields: CustomField[]) =>
    set((state) => {
      // Return a partial state update
      return {
        customFields: {
          ...state.customFields,
          fields
        }
      };
    }),
  clearFields: () =>
    set((state) => ({
      customFields: {
        ...state.customFields,
        fields: []
      }
    }))
});
